import React, { useEffect, useState } from 'react';
import { UploadCloudIcon, CheckCircleIcon, AlertCircleIcon, FileTextIcon } from 'lucide-react';
import { categories, departments, currentUser, knowledgeBaseArticles } from '../data/mockData';
export function TicketForm() {
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [department, setDepartment] = useState(currentUser.department);
  const [priority, setPriority] = useState('Medium');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [suggestedArticles, setSuggestedArticles] = useState<any[]>([]);
  // Smart suggestions effect
  useEffect(() => {
    if (subject.length > 3) {
      const matches = knowledgeBaseArticles.filter(a => a.title.toLowerCase().includes(subject.toLowerCase()) || a.tags.some(t => subject.toLowerCase().includes(t))).slice(0, 3);
      setSuggestedArticles(matches);
    } else {
      setSuggestedArticles([]);
    }
  }, [subject]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Mock API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  if (isSuccess) {
    return <div className="max-w-3xl mx-auto px-4 py-16 text-center" data-id="element-226">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-227">
          <CheckCircleIcon className="w-10 h-10 text-green-600" data-id="element-228" />
        </div>
        <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-229">
          Ticket Submitted Successfully
        </h2>
        <p className="text-lg text-slate-600 mb-8" data-id="element-230">
          Your request has been routed to the IT Support team. Your ticket ID is{' '}
          <strong className="text-slate-900" data-id="element-231">IT-2024-092</strong>.
        </p>
        <button onClick={() => {
        setIsSuccess(false);
        setSubject('');
        setDescription('');
        setCategory('');
      }} className="px-6 py-3 bg-blue-600 text-white font-medium rounded-xl hover:bg-blue-700 transition-colors" data-id="element-232">
          Submit Another Ticket
        </button>
      </div>;
  }
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-233">
      <div className="mb-8" data-id="element-234">
        <h1 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-235">
          Submit a Support Ticket
        </h1>
        <p className="text-slate-600" data-id="element-236">
          Provide details about your issue so we can help you as quickly as
          possible.
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-8" data-id="element-237">
        {/* Form Column */}
        <div className="flex-1 bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8" data-id="element-238">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-239">
            <div data-id="element-240">
              <label htmlFor="subject" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-241">
                Subject <span className="text-red-500" data-id="element-242">*</span>
              </label>
              <input type="text" id="subject" required value={subject} onChange={e => setSubject(e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-300 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition-shadow" placeholder="Brief summary of the issue" data-id="element-243" />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-244">
              <div data-id="element-245">
                <label htmlFor="category" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-246">
                  Category <span className="text-red-500" data-id="element-247">*</span>
                </label>
                <select id="category" required value={category} onChange={e => setCategory(e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-300 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none bg-white" data-id="element-248">
                  <option value="" data-id="element-249">Select a category...</option>
                  {categories.map(cat => <option key={cat} value={cat} data-id="element-250">
                      {cat}
                    </option>)}
                </select>
              </div>
              <div data-id="element-251">
                <label htmlFor="department" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-252">
                  Your Department
                </label>
                <select id="department" value={department} onChange={e => setDepartment(e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-300 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none bg-white" data-id="element-253">
                  {departments.filter(d => d !== 'All').map(dept => <option key={dept} value={dept} data-id="element-254">
                        {dept}
                      </option>)}
                </select>
              </div>
            </div>

            <div data-id="element-255">
              <label className="block text-sm font-medium text-slate-900 mb-2" data-id="element-256">
                Priority Level
              </label>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-id="element-257">
                {['Low', 'Medium', 'High', 'Critical'].map(level => <label key={level} className={`
                      flex items-center justify-center px-4 py-3 rounded-xl border cursor-pointer transition-all
                      ${priority === level ? level === 'Critical' ? 'border-red-600 bg-red-50 text-red-700 ring-1 ring-red-600' : level === 'High' ? 'border-amber-500 bg-amber-50 text-amber-700 ring-1 ring-amber-500' : 'border-blue-600 bg-blue-50 text-blue-700 ring-1 ring-blue-600' : 'border-slate-200 hover:bg-slate-50 text-slate-700'}
                    `} data-id="element-258">
                    <input type="radio" name="priority" value={level} checked={priority === level} onChange={() => setPriority(level)} className="sr-only" data-id="element-259" />
                    <span className="font-medium text-sm" data-id="element-260">{level}</span>
                  </label>)}
              </div>
            </div>

            <div data-id="element-261">
              <label htmlFor="description" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-262">
                Description <span className="text-red-500" data-id="element-263">*</span>
              </label>
              <p className="text-xs text-slate-500 mb-2" data-id="element-264">
                Include details like error messages, when the issue started, and
                steps you've already tried.
              </p>
              <textarea id="description" required rows={5} value={description} onChange={e => setDescription(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-blue-600 focus:border-transparent outline-none transition-shadow resize-y" placeholder="Describe the issue in detail..." data-id="element-265" />
            </div>

            <div data-id="element-266">
              <label className="block text-sm font-medium text-slate-900 mb-2" data-id="element-267">
                Attachments (Optional)
              </label>
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-slate-300 border-dashed rounded-xl hover:bg-slate-50 transition-colors cursor-pointer" data-id="element-268">
                <div className="space-y-1 text-center" data-id="element-269">
                  <UploadCloudIcon className="mx-auto h-12 w-12 text-slate-400" data-id="element-270" />
                  <div className="flex text-sm text-slate-600 justify-center" data-id="element-271">
                    <span className="relative cursor-pointer bg-transparent rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none" data-id="element-272">
                      <span data-id="element-273">Upload a file</span>
                    </span>
                    <p className="pl-1" data-id="element-274">or drag and drop</p>
                  </div>
                  <p className="text-xs text-slate-500" data-id="element-275">
                    PNG, JPG, PDF up to 10MB
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-4 flex items-center justify-end space-x-4 border-t border-slate-100" data-id="element-276">
              <button type="button" className="px-6 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-100 rounded-xl transition-colors" data-id="element-277">
                Cancel
              </button>
              <button type="submit" disabled={isSubmitting} className="px-6 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-xl hover:bg-blue-700 transition-colors disabled:opacity-70 flex items-center" data-id="element-278">
                {isSubmitting ? 'Submitting...' : 'Submit Ticket'}
              </button>
            </div>
          </form>
        </div>

        {/* Smart Suggestions Sidebar */}
        <div className="w-full lg:w-80 xl:w-96 flex-shrink-0" data-id="element-279">
          <div className="bg-slate-50 rounded-2xl border border-slate-200 p-6 sticky top-24" data-id="element-280">
            <h3 className="text-lg font-bold text-slate-900 mb-4 flex items-center" data-id="element-281">
              <AlertCircleIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-282" />
              These might help
            </h3>

            {subject.length < 4 ? <div className="text-center py-8" data-id="element-283">
                <FileTextIcon className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-284" />
                <p className="text-sm text-slate-500" data-id="element-285">
                  Type a subject to see suggested knowledge base articles.
                </p>
              </div> : suggestedArticles.length > 0 ? <div className="space-y-4" data-id="element-286">
                {suggestedArticles.map(article => <div key={article.id} className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm hover:border-blue-300 cursor-pointer transition-colors" data-id="element-287">
                    <h4 className="font-medium text-slate-900 text-sm mb-1 line-clamp-2" data-id="element-288">
                      {article.title}
                    </h4>
                    <p className="text-xs text-slate-500 line-clamp-2" data-id="element-289">
                      {article.summary}
                    </p>
                  </div>)}
                <p className="text-xs text-center text-slate-500 pt-2" data-id="element-290">
                  Did one of these solve your issue? You can skip submitting the
                  ticket!
                </p>
              </div> : <div className="text-center py-8" data-id="element-291">
                <p className="text-sm text-slate-500" data-id="element-292">
                  No matching articles found. Please proceed with submitting
                  your ticket.
                </p>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}